document.addEventListener('DOMContentLoaded', () => {
  const WARRANTY_VARIANT_ID = 44464250650824;

  const addonEl = document.querySelector('.warranty-addon');
  const checkbox = document.querySelector('.warranty-checkbox');

  if (!addonEl || !checkbox) return;

  let hasWarrantyInCart = false;

  function setAddonVisible(isVisible) {
    addonEl.classList.remove('is-loading');
    addonEl.style.display = isVisible ? '' : 'none';
    if (!isVisible) checkbox.checked = false;
  }

  async function fetchCartAndSync() {
    try {
      const res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });
      const cart = await res.json();
      hasWarrantyInCart = (cart.items || []).some(it => Number(it.id) === WARRANTY_VARIANT_ID);
      setAddonVisible(!hasWarrantyInCart);
    } catch (e) {
      setAddonVisible(true);
    }
  }

  // ✅ Only one cart fetch on initial page load (prevents flash + sets state)
  fetchCartAndSync();

  const originalFetch = window.fetch;

  window.fetch = async function (input, init = {}) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartAdd = url.includes('/cart/add');
    const isCartChange = url.includes('/cart/change');
    const isCartUpdate = url.includes('/cart/update');
    const isCartClear = url.includes('/cart/clear');

    // Append warranty to add-to-cart payload when checked
    if (isCartAdd && checkbox.checked && !hasWarrantyInCart) {
      try {
        if (init && init.body && typeof init.body === 'string') {
          const body = JSON.parse(init.body);

          if (body && body.id) {
            init.body = JSON.stringify({
              items: [
                { id: body.id, quantity: body.quantity || 1 },
                { id: WARRANTY_VARIANT_ID, quantity: 1, properties: { Warranty: 'Lifetime' } }
              ]
            });

            hasWarrantyInCart = true;
            setAddonVisible(false);
          } else if (body && Array.isArray(body.items)) {
            body.items.push({
              id: WARRANTY_VARIANT_ID,
              quantity: 1,
              properties: { Warranty: 'Lifetime' }
            });

            init.body = JSON.stringify(body);

            hasWarrantyInCart = true;
            setAddonVisible(false);
          }
        }
      } catch (e) {
        // fall through
      }
    }

    const response = await originalFetch(input, init);

    // After cart mutations, try to update state WITHOUT extra /cart.js call
    if ((isCartChange || isCartUpdate || isCartClear) && response && response.ok) {
      try {
        // Clone so we don't consume the body (theme may read it)
        const clone = response.clone();
        const ct = clone.headers.get('content-type') || '';

        // Many themes request JSON from these endpoints
        if (ct.includes('application/json')) {
          const data = await clone.json();

          // If this endpoint returned the cart object:
          const items = data.items || (data.cart && data.cart.items);

          if (Array.isArray(items)) {
            hasWarrantyInCart = items.some(it => Number(it.id) === WARRANTY_VARIANT_ID);
            setAddonVisible(!hasWarrantyInCart);
            return response; // ✅ no extra fetch
          }
        }
      } catch (e) {
        // ignore and fall back
      }

      // Fallback only if we couldn't infer state
      fetchCartAndSync();
    }

    // Clear always means warranty is gone
    if (isCartClear && response && response.ok) {
      hasWarrantyInCart = false;
      setAddonVisible(true);
    }

    return response;
  };
});
